// libraries
import { Link } from "react-router-dom";

// assets
import hero from "../../assets/hero.jpg";

const Hero = () => {
  return (
    <div className="carousel-item">
      <div
        className="carousel-item-sub"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)),url("${hero}")`,
        }}
      >
        <h1 className="carousel-heading text-center">Plan Shop Cook</h1>
        <h2 className="text-center carousel-subtitle">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempore,
          nostrum.
        </h2>
        <Link
          to="/submit-recipe"
          className="mt-5 px-5 py-3 btn btn-primary submit-recipe-btn"
        >
          Submit Recipe
        </Link>
      </div>
    </div>
  );
};

export default Hero;
